export function getDrivingTimeFactorFromBaseFactor(speedFactor: number): number {
  return Math.abs(speedFactor) / 100
}
